import { Button, Tag, Typography, Space } from "antd";
import { ArrowRightOutlined, EditOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { userDetailsPath } from "./routes";
import TimeAgo from "../components/TimeAgo";

const { Text } = Typography;

export const usersTable = (offset, onEdit, canEditUser) => [
  {
    title: "Sr. No",
    key: "serial_no",
    className: "col-index",
    width: 72,
    responsive: ["sm"],
    render: (_, __, index) => <Text>{offset + index + 1}</Text>,
  },
  {
    title: "First Name",
    key: "first_name",
    dataIndex: "first_name",
  },
  {
    title: "Last Name",
    key: "last_name",
    dataIndex: "last_name",
  },
  {
    title: "E-mail address",
    key: "email_address",
    dataIndex: "email_address",
  },
  {
    title: "Status",
    key: "is_active",
    dataIndex: "is_active",
    render: (item) => (
      <Tag color={item ? "success" : "error"}>
        {item ? "Active" : "Inactive"}
      </Tag>
    ),
  },
  {
    title: "Created At",
    key: "created_at",
    className: "col-date",
    responsive: ["md"],
    render: (_, record) => <TimeAgo value={record?.created_at} />,
  },
  {
    title: "Action",
    key: "action",
    align: "right",
    className: "col-actions",
    fixed: "right",
    render: (_, record) => (
      <Space>
        <Link to={userDetailsPath(record.uuid)}>
          <Button type="primary" icon={<ArrowRightOutlined />}>
            Details
          </Button>
        </Link>

        {canEditUser && (
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          >
            Edit
          </Button>
        )}
      </Space>
    ),
  },
];
